export const DEFAULT_MINIMUM_YEAR = 1900;
export const DEFAULT_MAXIMUM_YEAR = 2100;
